export default "__VITE_ASSET__48eadb63__"